export const GET_DATA_REQUEST= 'GET_DATA_REQUEST'
export const GET_DATA_SUCCESS= 'GET_DATA_SUCCESS'
export const GET_DATA_FAILURE= 'GET_DATA_FAILURE'